/**
 * Validazione degli eventi custom contro il piano eventi (trackingPlan.json).
 *
 * Stessa logica di cil-server/src/services/umami/trackingPlan.js: il JSON è
 * identico nei due repo. Il client non invia eventi sbagliati, il server li
 * scarta comunque.
 *
 * - evento non nel piano → scartato
 * - proprietà non prevista o con valore non ammesso → tolta
 * - proprietà obbligatoria mancante (anche perché tolta) → evento scartato
 */
import PLAN from './trackingPlan.json';

const MAX_STRING_LENGTH = 100;
const hasOwn = (object, key) =>
  Object.prototype.hasOwnProperty.call(object, key);

const PATTERNS = Object.fromEntries(
  Object.entries(PLAN.patterns || {}).map(([key, source]) => [
    key,
    new RegExp(source),
  ])
);

const isValidValue = (prop, value) => {
  if (prop.type === 'number') {
    if (typeof value !== 'number' || !Number.isFinite(value)) return false;
    if (prop.min !== undefined && value < prop.min) return false;
    if (prop.max !== undefined && value > prop.max) return false;
    return true;
  }
  if (prop.type === 'boolean') return typeof value === 'boolean';
  if (prop.type !== 'string' || typeof value !== 'string') return false;
  if (!value || value.length > (prop.maxLength || MAX_STRING_LENGTH))
    return false;
  if (prop.enum && !prop.enum.includes(value)) return false;
  if (prop.pattern && !PATTERNS[prop.pattern]?.test(value)) return false;
  return true;
};

/** @returns {{ ok: boolean, data: object, problems: string[] }} */
export const validateEvent = (name, data) => {
  const spec = hasOwn(PLAN.events, name) ? PLAN.events[name] : null;
  if (!spec)
    return { ok: false, data: {}, problems: [`evento non previsto: ${name}`] };

  const input =
    data && typeof data === 'object' && !Array.isArray(data) ? data : {};
  const properties = spec.properties || {};
  const clean = {};
  const problems = [];

  Object.entries(input).forEach(([key, value]) => {
    if (value === undefined || value === null) return;
    const prop = hasOwn(properties, key) ? properties[key] : null;
    if (!prop) problems.push(`proprietà non prevista: ${key}`);
    else if (!isValidValue(prop, value))
      problems.push(`valore non valido: ${key}`);
    else clean[key] = value;
  });

  let ok = true;
  Object.entries(properties).forEach(([key, prop]) => {
    if (prop.required && !hasOwn(clean, key)) {
      ok = false;
      problems.push(`proprietà obbligatoria mancante: ${key}`);
    }
  });

  return { ok, data: clean, problems };
};

export const TRACKED_EVENTS = Object.keys(PLAN.events);

export default PLAN;
